import { PostalAreas } from "us.common/constants";
import { initialState } from "./State";
const {
  GET_POSTAL_AREAS,
  GET_POSTAL_AREAS_SUCCESS,
  GET_POSTAL_AREAS_FAIL,
  SAVE_POSTAL_AREA,
  SAVE_POSTAL_AREA_SUCCESS,
  SAVE_POSTAL_AREA_FAIL,
  UPDATE_POSTAL_AREA,
  UPDATE_POSTAL_AREA_SUCCESS,
  UPDATE_POSTAL_AREA_FAIL,
  SET_POSTAL_AREA_DRAWER,
  DELETE_POSTAL_AREA,
  DELETE_POSTAL_AREA_SUCCESS,
  DELETE_POSTAL_AREA_FAIL,
} = PostalAreas;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_POSTAL_AREAS:
      return Object.assign({}, state, {
        postalAreas: {
          ...state.postalAreas,
          isLoading: true,
        },
      });
    case GET_POSTAL_AREAS_SUCCESS:
      return Object.assign({}, state, {
        postalAreas: {
          ...state.postalAreas,
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_POSTAL_AREAS_FAIL:
      return Object.assign({}, state, {
        postalAreas: {
          ...state.postalAreas,
          isLoading: false,
        },
      });
    case SAVE_POSTAL_AREA:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          isLoading: true,
        },
      });
    case SAVE_POSTAL_AREA_SUCCESS:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          data: payload.data,
          isLoading: false,
        },
      });
    case SAVE_POSTAL_AREA_FAIL:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          isLoading: false,
        },
      });
    case UPDATE_POSTAL_AREA:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          isLoading: true,
        },
      });
    case UPDATE_POSTAL_AREA_SUCCESS:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          data: payload.data,
          isLoading: false,
        },
      });
    case UPDATE_POSTAL_AREA_FAIL:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          isLoading: false,
        },
      });
    case SET_POSTAL_AREA_DRAWER:
      return Object.assign({}, state, {
        postalAreaDrawer: {
          ...state.postalAreaDrawer,
          visible: payload.data.visible,
          action: payload.data.action,
          record: payload.data.record,
        },
      });
    case DELETE_POSTAL_AREA:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          isLoading: true,
        },
      });
    case DELETE_POSTAL_AREA_SUCCESS:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          data: payload.data,
          isLoading: false,
        },
      });
    case DELETE_POSTAL_AREA_FAIL:
      return Object.assign({}, state, {
        newPostalArea: {
          ...state.newPostalArea,
          isLoading: false,
        },
      });
    default:
      return state;
  }
};
